import {
  FETCH_SPECIALTYDETAILS_REQUEST,
  FETCH_SPECIALTYDETAILS_SUCCESS,
  FETCH_SPECIALTYDETAILS_ERROR,
  FETCH_SPECIALTIES_REQUEST,
  FETCH_SPECIALTIES_SUCCESS,
  FETCH_SPECIALTIES_ERROR,
  UNFOLLOW_SPECIALTY_REQUEST,
  UNFOLLOW_SPECIALTY_SUCCESS,
  UNFOLLOW_SPECIALTY_ERROR,
  CLEAR_SPECIALTY_DETAILS,
  FOLLOW_SPECIALTY_REQUEST,
  FOLLOW_SPECIALTY_SUCCESS,
  FOLLOW_SPECIALTY_ERROR,
} from "../actionTypes";
import apiService from "../../util/ApiService";
import {
  logBrowseItemFollowedSuccess,
  logBrowseItemFollowedFailed,
  logBrowseItemUnfollowedSuccess,
  logBrowseItemUnfollowedFailed,
} from "../../util/analytics";

export const getType = (path) => {
  if (path?.includes("/browse/patient-information")) {
    return "patient-information";
  }
};

export const fetchSpecialtyDetails = async (dispatch, specialtyId, path) => {
  dispatch({ type: FETCH_SPECIALTYDETAILS_REQUEST });
  try {
    const response = await apiService.getSpecialtyDetails(
      specialtyId,
      getType(path)
    );
    dispatch({
      type: FETCH_SPECIALTYDETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SPECIALTYDETAILS_ERROR,
    });
  }
};

export const fetchSpecialties = async (dispatch, path) => {
  dispatch({ type: FETCH_SPECIALTIES_REQUEST });
  try {
    const response = await apiService.getSpecialties(getType(path));
    dispatch({
      type: FETCH_SPECIALTIES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SPECIALTIES_ERROR,
    });
  }
};

export const unFollowSpecialty = async (
  dispatch,
  specialtyId,
  affordance,
  feedId,
  isOnSpecialtyDetails
) => {
  dispatch({ type: UNFOLLOW_SPECIALTY_REQUEST });
  try {
    const response = await apiService.deleteFollowSpecialty(
      specialtyId,
      feedId
    );
    dispatch({
      type: UNFOLLOW_SPECIALTY_SUCCESS,
      payload: { response: response.data, isOnSpecialtyDetails },
    });
    logBrowseItemUnfollowedSuccess(affordance, specialtyId);
  } catch (error) {
    dispatch({
      type: UNFOLLOW_SPECIALTY_ERROR,
      payload: {
        followError: {
          message: "Follow is currently unavailable, please try again shortly.",
        },
      },
    });
    logBrowseItemUnfollowedFailed(affordance, specialtyId);
  }
};

export const followSpecialty = async (
  dispatch,
  apiPath,
  specialtyId,
  affordance,
  feedId,
  subscriptionType,
  isOnSpecialtyDetails
) => {
  dispatch({ type: FOLLOW_SPECIALTY_REQUEST });
  try {
    const response = await apiService.followSpecialty(
      apiPath,
      feedId,
      subscriptionType
    );
    dispatch({
      type: FOLLOW_SPECIALTY_SUCCESS,
      payload: { response: response.data, isOnSpecialtyDetails },
    });
    logBrowseItemFollowedSuccess(affordance, specialtyId, subscriptionType);
  } catch (error) {
    dispatch({
      type: FOLLOW_SPECIALTY_ERROR,
      payload: {
        followError: {
          message: "Follow is currently unavailable, please try again shortly.",
        },
      },
    });
    logBrowseItemFollowedFailed(affordance, specialtyId, subscriptionType);
  }
};

export const clearSpecialtyDetails = (dispatch) => {
  dispatch({ type: CLEAR_SPECIALTY_DETAILS });
};
